// ==============================
// TSV Custom Mega Menu v2
// ==============================
// Desktop: hover with intent delay + keyboard navigation
// Mobile/tablet: click toggle + accordion columns
// Brands: permanent ★ Featured tab + A-Z letter switching
// Panels: Liquid is the single source of truth for vendors
// ==============================

(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  var MOBILE_MQ = window.matchMedia('(max-width: 749.98px)');
  var HOVER_CLOSE_DELAY = 220; // ms – fixes diagonal mouse movement problem
  var HOVER_OPEN_DELAY = 90;   // ms – intent delay so sweeping across tabs doesn't flicker-open

  function initMegaMenu() {
    var mega = document.querySelector('.custom-mega-menu');
    if (!mega) return;

    var navItems = Array.from(mega.querySelectorAll('.custom-mega-menu__nav-item'));
    var panels = Array.from(mega.querySelectorAll('.custom-mega-menu__panel'));
    var backdrop = mega.querySelector('.custom-mega-menu__backdrop');
    var navEl = mega.querySelector('.custom-mega-menu__nav');
    var panelsEl = mega.querySelector('.custom-mega-menu__panels');

    if (!navItems.length || !panels.length) return;

    var currentKey = null;
    var closeTimer = null;
    var openTimer = null;
    var navBarClosePending = false;
    var ignoreHoverUntil = Date.now() + 800; // prevent flash-open on page load

    // ========================================
    // Helpers
    // ========================================

    function sizePanelForMobile(panel) {
      if (!MOBILE_MQ.matches || !panel) return;
      var rect = panel.getBoundingClientRect();
      var available = window.innerHeight - rect.top;
      // max-height (not fixed height): short panels shrink to their content
      // (no empty white space), tall panels cap to the viewport and scroll
      // internally. No keyboard is raised inside the menu on mobile, so this
      // never needs to track the on-screen keyboard.
      panel.style.maxHeight = available + 'px';
      panel.style.height = '';
    }

    function clearPanelSize(panel) {
      if (panel) { panel.style.height = ''; panel.style.maxHeight = ''; }
    }

    function lockBodyScroll() {
      if (!MOBILE_MQ.matches) return;
      document.documentElement.classList.add('mm-body-locked');
    }

    function unlockBodyScroll() {
      document.documentElement.classList.remove('mm-body-locked');
    }

    function setActive(key) {
      clearTimeout(closeTimer);
      mega.classList.add('is-open');
      currentKey = key;

      navItems.forEach(function (btn) {
        var isActive = btn.dataset.menuKey === key;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.menuPanel === key);
      });

      if (backdrop) backdrop.classList.add('is-visible');
      lockBodyScroll();

      // Set exact panel height on mobile so scroll works perfectly
      var activePanel = panels.find(function (p) { return p.dataset.menuPanel === key; });
      if (activePanel) {
        requestAnimationFrame(function () {
          sizePanelForMobile(activePanel);
        });
      }
    }

    function setTabOnly(key) {
      mega.classList.remove('is-open');
      currentKey = key;

      navItems.forEach(function (btn) {
        var isActive = btn.dataset.menuKey === key;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (p) { p.classList.remove('is-active'); });
      if (backdrop) backdrop.classList.remove('is-visible');
    }

    function closeAll() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      navBarClosePending = false;
      mega.classList.remove('is-open');
      currentKey = null;

      navItems.forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      });

      // Keep the last panel's .is-active so CSS can fade it OUT (opacity +
      // transform) instead of snapping to display:none. It stays visually
      // hidden (opacity:0/visibility:hidden) while the menu is closed and is
      // re-used or swapped on the next open.
      panels.forEach(function (p) {
        clearPanelSize(p);
      });
      if (backdrop) backdrop.classList.remove('is-visible');
      unlockBodyScroll();
    }

    // Close buttons inside panels
    mega.querySelectorAll('.custom-mega-menu__close').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });

    // Backdrop click-to-close
    if (backdrop) {
      backdrop.addEventListener('click', closeAll);
    }

    // Click outside mega menu to close
    document.addEventListener('click', function (e) {
      if (!mega.contains(e.target) && mega.classList.contains('is-open')) {
        closeAll();
      }
    });

    // ========================================
    // Desktop: hover with intent delay
    // ========================================

    function onNavHover(e) {
      if (Date.now() < ignoreHoverUntil) return;
      var key = e.currentTarget.dataset.menuKey;
      if (!key) return;
      clearTimeout(openTimer);
      // Already open → switch panels instantly for snappy navigation.
      // Closed → wait a beat for hover intent so a quick sweep doesn't open it.
      if (mega.classList.contains('is-open')) { setActive(key); return; }
      openTimer = setTimeout(function () { setActive(key); }, HOVER_OPEN_DELAY);
    }

    function onNavHoverLeave() {
      clearTimeout(openTimer);
    }

    function onMegaLeave() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, HOVER_CLOSE_DELAY);
    }

    function onMegaEnter() {
      clearTimeout(closeTimer);
      navBarClosePending = false;
    }

    // Hover over the blue nav bar: only the actual tab links keep the menu
    // open. Hovering the empty areas left/right of the tabs starts the close
    // (a single timer, not reset by continued movement).
    function onNavBarMove(e) {
      if (!mega.classList.contains('is-open')) return;
      if (e.target.closest('.custom-mega-menu__nav-item')) {
        navBarClosePending = false;
        clearTimeout(closeTimer);
      } else if (!navBarClosePending) {
        navBarClosePending = true;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { navBarClosePending = false; closeAll(); }, HOVER_CLOSE_DELAY);
      }
    }

    function enableDesktop() {
      mega.classList.add('custom-mega-menu--desktop');
      navItems.forEach(function (btn) {
        btn.removeEventListener('click', onNavClickMobile);
        btn.addEventListener('mouseenter', onNavHover);
        btn.addEventListener('mouseleave', onNavHoverLeave);
      });
      mega.addEventListener('mouseleave', onMegaLeave);
      mega.addEventListener('mouseenter', onMegaEnter);
      // Close-on-mouse-away: the safe zone is the nav bar + the open panel.
      // Moving onto the backdrop (anywhere else on screen) starts the close
      // timer; moving back onto the nav or panel cancels it. This fixes the
      // "stuck open" issue where the full-screen backdrop kept the menu alive.
      if (backdrop) backdrop.addEventListener('mouseenter', onMegaLeave);
      if (navEl) navEl.addEventListener('mouseover', onNavBarMove);
      if (panelsEl) panelsEl.addEventListener('mouseenter', onMegaEnter);
    }

    function disableDesktop() {
      mega.classList.remove('custom-mega-menu--desktop');
      mega.removeEventListener('mouseleave', onMegaLeave);
      mega.removeEventListener('mouseenter', onMegaEnter);
      navItems.forEach(function (btn) {
        btn.removeEventListener('mouseenter', onNavHover);
      });
    }

    // ========================================
    // Mobile / tablet: click toggle
    // ========================================

    function onNavClickMobile(e) {
      var key = e.currentTarget.dataset.menuKey;
      if (!key) return;

      if (e.currentTarget.classList.contains('is-active') && mega.classList.contains('is-open')) {
        closeAll();
      } else {
        setActive(key);
      }
    }

    function enableMobile() {
      mega.classList.add('custom-mega-menu--mobile');
      navItems.forEach(function (btn) {
        btn.removeEventListener('mouseenter', onNavHover);
        btn.removeEventListener('mouseleave', onNavHoverLeave);
        btn.addEventListener('click', onNavClickMobile);
      });
      mega.removeEventListener('mouseleave', onMegaLeave);
      mega.removeEventListener('mouseenter', onMegaEnter);
      if (backdrop) backdrop.removeEventListener('mouseenter', onMegaLeave);
      if (navEl) navEl.removeEventListener('mouseover', onNavBarMove);
      if (panelsEl) panelsEl.removeEventListener('mouseenter', onMegaEnter);
    }

    function disableMobile() {
      mega.classList.remove('custom-mega-menu--mobile');
      navItems.forEach(function (btn) {
        btn.removeEventListener('click', onNavClickMobile);
      });
    }

    // ========================================
    // Keyboard navigation
    // ========================================

    mega.addEventListener('keydown', function (e) {
      var activeEl = document.activeElement;

      // Escape closes the menu
      if (e.key === 'Escape' && mega.classList.contains('is-open')) {
        var prevKey = currentKey;
        closeAll();
        var focusBtn = navItems.find(function (b) { return b.dataset.menuKey === prevKey; }) || navItems[0];
        if (focusBtn) focusBtn.focus();
        e.preventDefault();
        return;
      }

      // Arrow keys navigate between tabs
      if (activeEl && activeEl.classList.contains('custom-mega-menu__nav-item')) {
        var idx = navItems.indexOf(activeEl);
        if (idx < 0) return;

        var nextIdx = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          nextIdx = (idx + 1) % navItems.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          nextIdx = (idx - 1 + navItems.length) % navItems.length;
        } else if (e.key === 'Home') {
          nextIdx = 0;
        } else if (e.key === 'End') {
          nextIdx = navItems.length - 1;
        }

        if (nextIdx >= 0) {
          e.preventDefault();
          navItems[nextIdx].focus();
          if (mega.classList.contains('is-open')) {
            setActive(navItems[nextIdx].dataset.menuKey);
          }
        }
      }
    });

    // ========================================
    // Brands A-Z interaction
    // JS fills all letter panels from the
    // hardcoded brand list (shop.vendors only
    // returns brands with live products).
    // Also injects Featured panel + handles
    // letter switching with slide animation.
    // ========================================

    function initBrandPanels() {
      // Full brand catalogue – this is the source of truth because
      // shop.vendors only returns vendors with live products, which
      // may not cover the full list you want to display.
      var RAW_VENDORS = '18.21 Man Made|4711|Abercrombie & Fitch|Acqua di Parma|Adolfo Dominguez|Afnan|Agatha Ruiz De La Prada|Agua Brava|Agua De Sevilla|Agua Lavanda|Ajmal|Al Haramain|Al Wataniah|Alejandro Sanz|Alexandre J|Alvarez Gómez|Alyssa Ashley|Amichi|Amouage|Angel Schlesser|Annayake|Anouk|Antonio Banderas|Aqc Fragrances|Aquolina|Aramis|Ard Al Zaafaran|Aristo|Armaf|Armand Basi|Atkinsons|Ayat|Baldessarini|Balenciaga|Benetton|Beso Beach|Bharara|Bond No. 9|Boucheron|Brioni|Britney Spears|Brummel|Bruno Banani|Burberry|Bvlgari|Bvlgari Le Gemme|Byredo|Calvin Klein|Carolina Herrera|Caron|Carthusia|Cartier|Carven|Casamorati|Cerruti|Chanel|Chanson d\'Eau|Chevignon|Chloé|Chopard|Christina Aguilera|Clean|Coach|Coquette|Coronel Tapiocca|Courrèges|Cr7 Cristiano Ronaldo|Creed|Crossmen|Custo|D\'Orsay|David Beckham|Davidoff|Delisea|Devota & Lomba|Dior|Diptyque|Dolce & Gabbana|Don Algodón|Donna Karan|Drakkar|Dsquared2|Dunhill|Dupont|Ed Hardy|El Ganso|Elie Saab|Elizabeth Arden|Elizabeth Taylor|Emanuel Ungaro|Emir|English Lavender|Escada|Escentric Molecules|Estée Lauder|Etat Libre d\'Orange|Étienne Aigner|Fabergé|Fendi|Fidji|Franck Boclet|Frédéric Malle|Geoffrey Beene|Gianfranco Ferré|Giardini Di Toscana|Giorgio Beverly Hills|Gisada|Givenchy|Gloria Vanderbilt|Goutal Paris|Gritti|Grès|Gucci|Guerlain|Guess|Guy Laroche|Hackett|Halloween|Hanae Mori|Hannibal Laguna|Hermès|Hollister|Hugo Boss|Iceberg|Iggywoo|Initio Parfums Privés|Issey Miyake|Jacques Bogart|Jaguar|Jean Paul Gaultier|Jean-Louis Scherrer|Jennifer Lopez|Jil Sander|Jimmy Choo|Jo Malone|Joop|Jovan|Juicy Couture|Juliette Has a Gun|Kajal|Karl Lagerfeld|Kenzo|Khadlaj Perfumes|Kilian|Lacoste|Lalique|Lancaster|Lanvin|Lattafa|Laura Biagiotti|Legrain|Leonard Paris|Liu·jo|Loewe|Lolita Lempicka|Lorenzo Villoresi|L\'Occitane En Provence|Madonna|Maison Alhambra|Maison Asrar|Maison Francis Kurkdjian|Maison Margiela|Mancera|Mandarina Duck|Map of the Heart|Marc Jacobs|Mauboussin|Memo Paris|Metilina Valet|Michael Kors|Miller Harris|Missoni|Molinard|Moncler|Monotheme|Montale|Montana|Montblanc|Morgan|Moschino|Muhammad Ali|Myrurgia|Nabeel|Narciso Rodriguez|Nikos|Nina Ricci|Nishane|Obvious|Off-White|Oilily|One Direction|Orlov Paris|Orto Parisi|Oscar de la Renta|Pacha|Pal Zileri|Paloma Picasso|Parfums de Marly|Pascal Morabito|Pedro Del Hierro|Pepe Jeans|Pertegaz|Philipp Plein|Pino Silvestre|Police|Poseidon|Proraso|Quorum|Rabanne|Rasasi|Revlon|Rituals|Roberto Cavalli|Roberto Torretta|Rochas|Roger & Gallet|Roja Parfums|Roos & Roos|Réminiscence|Salvador Dali|Salvatore Ferragamo|Sarah Jessica Parker|Scalpers|Serge Lutens|Sergio Tacchini|Shakira|Shiseido|Sisley|Slava Zaïtsev|Stéphane Humbert Lucas|Swiss Arabian|Tabac|Ted Lapidus|The Merchant of Venice|Tiffany & Co|Titto Bluni|Tiziana Terenzi|Tom Ford|Tommy Hilfiger|Tous|Trussardi|Ulric De Varens|Van Cleef & Arpels|Vanderbilt|Vera Wang|Versace|Vicky Martin Berrocal|Victor|Victoria\'s Secret|Victorinox|Victorio & Lucchino|Visconti Di Modrone|Women\'secret|Xerjoff|Zadig & Voltaire|Zimaya'.split('|');

      // Permanent featured brands for the star tab
      var FEATURED = [
        { name: 'Hugo Boss',                url: '/collections/hugo-boss' },
        { name: 'Issey Miyake',             url: '/collections/issey-miyake' },
        { name: 'Jean Paul Gaultier',       url: '/collections/jean-paul-gaultier' },
        
        { name: 'Tom Ford',                 url: '/collections/tom-ford' },
        { name: 'Burberry',                 url: '/collections/burberry-her' },
        { name: 'Calvin Klein',             url: '/collections/calvin-klein' },
        { name: 'Jimmy Choo',              url: '/collections/jimmy-choo' },
        { name: 'Maison Francis Kurkdjian', url: '/collections/maison-francis-kurkdjian' },
        { name: 'Xerjoff',                  url: '/collections/xerjoff' },
        { name: 'Kilian',                   url: '/collections/kilian' },
        { name: 'Tiziana Terenzi',          url: '/collections/tiziana-terenzi' },
        { name: 'Acqua Di Parma',           url: '/collections/acqua-di-parma' },
        
      ];

      // Build vendor URL (fallback for brands without a dedicated collection)
      var vendorUrl = function (name) {
        return '/collections/vendors?q=' + encodeURIComponent(name);
      };

      // Lookup: brands with dedicated collections use that URL
      // in the A-Z tabs too (not just the Featured tab).
      // To add more brands, just add them to the FEATURED array above.
      var collectionMap = {};
      FEATURED.forEach(function (b) { collectionMap[b.name] = b.url; });
      // Additional brands with dedicated collections (not in Featured)
      collectionMap['Chloé'] = '/collections/chloe';

      function brandUrl(name) {
        return collectionMap[name] || vendorUrl(name);
      }

      // Group brands by first letter
      var groups = {};
      RAW_VENDORS.forEach(function (name) {
        var first = name.normalize('NFD').replace(/^\W+/, '').charAt(0).toUpperCase();
        var L = /[A-Z]/.test(first) ? first : 'A';
        if (!groups[L]) groups[L] = [];
        groups[L].push({ name: name, url: brandUrl(name) });
      });
      Object.keys(groups).forEach(function (L) {
        groups[L].sort(function (a, b) { return a.name.localeCompare(b.name); });
      });

      // Helper: render flat list of links (CSS grid handles columns)
      function renderCols(list) {
        var html = '';
        list.forEach(function (b) {
          html += '<a class="custom-mega-menu__brands-link" href="' + b.url + '">' + b.name + '</a>';
        });
        return html;
      }

      var ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

      mega.querySelectorAll('.custom-mega-menu__brands').forEach(function (area) {
        var lettersWrap = area.querySelector('.custom-mega-menu__brands-letters');
        var panelsWrap = area.querySelector('.custom-mega-menu__brands-panels');
        if (!lettersWrap || !panelsWrap) return;

        var letters = Array.from(lettersWrap.querySelectorAll('.custom-mega-menu__brands-letter'));
        var letterPanels = Array.from(panelsWrap.querySelectorAll('.custom-mega-menu__brands-panel'));
        if (!letters.length || !letterPanels.length) return;

        // --- Fill the Featured (star) panel ---
        var featuredPanel = panelsWrap.querySelector('[data-letter-panel="featured"]');
        if (featuredPanel && !featuredPanel.hasChildNodes()) {
          var fhtml = '<div class="custom-mega-menu__brands-featured-title">\u2605 Popular Brands</div>';
          fhtml += '<div class="custom-mega-menu__brands-cols">' + renderCols(FEATURED) + '</div>';
          featuredPanel.innerHTML = fhtml;
        }

        // --- Fill each A-Z panel from the hardcoded list ---
        ALPHABET.forEach(function (L) {
          var panel = panelsWrap.querySelector('[data-letter-panel="' + L + '"]');
          if (!panel) return;

          var list = groups[L] || [];
          if (!list.length) {
            panel.innerHTML = '<p class="custom-mega-menu__brands-empty">No brands under ' + L + '.</p>';
            return;
          }
          panel.innerHTML = '<div class="custom-mega-menu__brands-cols">' + renderCols(list) + '</div>';
        });

        // Mark empty letters
        letters.forEach(function (btn) {
          var raw = btn.dataset.letter || '';
          if (raw === 'featured') return;
          var L = raw.toUpperCase();
          if (!groups[L] || !groups[L].length) {
            btn.classList.add('is-empty');
          } else {
            btn.classList.remove('is-empty');
          }
        });

        // --- Set star as initial active ---
        var activeIndex = letters.findIndex(function (b) {
          return (b.dataset.letter || '').toLowerCase() === 'featured';
        });
        if (activeIndex < 0) activeIndex = 0;

        var initialLetter = (letters[activeIndex] && letters[activeIndex].dataset.letter) || '';

        letters.forEach(function (btn, idx) {
          btn.classList.toggle('is-active', idx === activeIndex);
        });

        letterPanels.forEach(function (panel) {
          var match = panel.getAttribute('data-letter-panel') === initialLetter;
          panel.classList.toggle('is-active', match);
          panel.classList.remove('slide-from-left', 'slide-from-right');
        });

        // --- Letter click switching with slide direction ---
        letters.forEach(function (btn, idx) {
          btn.addEventListener('click', function () {
            if (btn.dataset.letter !== 'featured' && btn.classList.contains('is-empty')) return;
            if (idx === activeIndex) return;

            var dir = idx > activeIndex ? 'right' : 'left';
            var newLetter = btn.dataset.letter;

            letters.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });

            letterPanels.forEach(function (panel) {
              var match = panel.getAttribute('data-letter-panel') === newLetter;
              panel.classList.toggle('is-active', match);
              panel.classList.remove('slide-from-left', 'slide-from-right');
              if (match) {
                panel.classList.add(dir === 'right' ? 'slide-from-right' : 'slide-from-left');
              }
            });

            activeIndex = idx;
          });
        });
      });
    }

    // ========================================
    // Mobile columns – no accordion
    // (All links visible and scrollable;
    //  accordion JS removed – CSS handles display)
    // ========================================

    // (Swipe-to-close removed – was fighting normal scroll)

    // ========================================
    // Skeleton loader for product cards
    // ========================================

    (function initSkeletonLoader() {
      mega.querySelectorAll('.mega-menu-card').forEach(function (card) {
        var img = card.querySelector('.mega-menu-card__media img') ||
                  card.querySelector('.tsv-mega-card__image');
        if (!img) return;

        if (!img.complete) {
          card.classList.add('mega-menu-card--skeleton');
          img.addEventListener('load', function () {
            card.classList.remove('mega-menu-card--skeleton');
          });
          img.addEventListener('error', function () {
            card.classList.remove('mega-menu-card--skeleton');
          });
        }
      });
    })();

    // ========================================
    // Breakpoint wiring
    // ========================================

    function onBreakpointChange(e) {
      if (e.matches) {
        disableMobile();
        enableDesktop();
      } else {
        disableDesktop();
        enableMobile();
      }
    }

    onBreakpointChange(DESKTOP_MQ);
    DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    initBrandPanels();

    // Default active tab (e.g. Boutique collection page)
    var defaultItem = mega.querySelector('.custom-mega-menu__nav-item[data-default-active="true"]');
    if (defaultItem && !currentKey) {
      setTabOnly(defaultItem.dataset.menuKey);
      requestAnimationFrame(function () {
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        if (backdrop) backdrop.classList.remove('is-visible');
      });
    }
  }

  // ========================================
  // Announcement bar offset for sticky header
  // ========================================

  function initAnnouncementOffset() {
    var root = document.documentElement;

    function calcOffset() {
      var bar = document.querySelector('.announcement-bar, .announcement-bar-section');
      if (!bar) {
        root.style.setProperty('--tsv-announcement-offset', '0px');
        return;
      }
      var rect = bar.getBoundingClientRect();
      var height = rect.bottom > 0 ? rect.height : 0;
      root.style.setProperty('--tsv-announcement-offset', height + 'px');
    }

    calcOffset();
    var _mmRaf = 0;
    function debouncedCalcOffset() {
      cancelAnimationFrame(_mmRaf);
      _mmRaf = requestAnimationFrame(calcOffset);
    }
    window.addEventListener('scroll', debouncedCalcOffset, { passive: true });
    window.addEventListener('resize', debouncedCalcOffset);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMegaMenu();
    initAnnouncementOffset();
  });
})();